/* COMPONENT IMPORTS*/
import { AuthContext } from "../../AuthProvider";

// Imagem
import logout from "../../images/logout.svg";

/* MODULE IMPORTS */
import React, { Component } from "react";

export class Logout extends Component {
  static contextType = AuthContext;

  logout = () => {
    window.sessionStorage.setItem("showedElectionPopup", "false");

    const { msalInstance } = this.context;

    if (msalInstance) {
      msalInstance.logoutRedirect({
        postLogoutRedirectUri: "https://www.montepio.org",
        idTokenHint: this.context.idToken,
      });
    }
  };

  render() {
    return (
      <div className="header-bar" onClick={this.logout}>
        <div className="logout-name">Sair</div>
        <img
          src={logout}
          alt="Logout da conta"
          width="18.4px"
          height="24px"></img>
      </div >
    );
  }
}
